// Base API URL
import { API_BASE_CMS } from "helper/environment";
// ===============================
// Drupal APIs
// ===============================
// Endpoints
export const API_ENDPOINTS = {
    MENU_MAIN: `${API_BASE_CMS}/jsonapi/menu_items/main`,
    Header: `${API_BASE_CMS}/jsonapi/node/logosite_settings?include=field_site_logo.field_media_image,field_site_logo.field_media_svg_image,field_icon_images.field_media_image,field_icon_images.field_media_svg_image`,
    FOOTER: `${API_BASE_CMS}/jsonapi/node/foote?include=field_footer_columns,field_social_links,field_footer_image.field_media_image,field_footer_image.field_media_svg_image`,
};
